<ng-container>
  <div class="page-header-bar">
    <div class="content85percent">
      <h1 class="float-start">Manage Orders</h1>
      <ng-container>
        <div class="float-end"
             [showIfHasCapability]="[
        {
          capabilityString: 'CanCreateOrder',
          type: 'system'
        },
        {
          capabilityString: 'CanCreateOrder',
          type: 'client'
        }
       ]">
          <button type="button"
                  class="btn-primary icon"
                  (click)="openOrderCreateModal()">
            <mat-icon svgIcon="addCircle"></mat-icon> Create Order
          </button>
        </div>
      </ng-container>
    </div>
  </div>
  <div class="content85percent card-style">
    <app-filter-form [isSystemUserOrSettlementAgent]="isSystemUserOrSettlementAgent"></app-filter-form>
    <div class="heading-18 text-start">Order Search</div>
    <table id="orderSearchSectionTable" class="table table-responsive"
           data-cy="orderTableSection">
      <thead>
        <tr>
          <th scope="col" class="sortable column-width-9vw" [ngClass]="{'active-sort-column': sortColumn == 'PackageId'}" (click)="sortByColumn('PackageId')" (keyup)="handleKeyUp($event, 'PackageId')">
            Order Number
            <mat-icon class="tooltip-icon" svgIcon="arrowDown" *ngIf="!isSortDirectionAscending && sortColumn === 'PackageId'"></mat-icon>
            <mat-icon class="tooltip-icon" svgIcon="arrowUp" *ngIf="isSortDirectionAscending && sortColumn === 'PackageId'"></mat-icon>
          </th>
          <th scope="col" class="sortable column-width-9vw" [ngClass]="{'active-sort-column': sortColumn == 'ClientLoanNumber'}" (click)="sortByColumn('ClientLoanNumber')" (keyup)="handleKeyUp($event, 'ClientLoanNumber')">
            Loan Number
            <mat-icon class="tooltip-icon" svgIcon="arrowDown" *ngIf="!isSortDirectionAscending && sortColumn === 'ClientLoanNumber'"></mat-icon>
            <mat-icon class="tooltip-icon" svgIcon="arrowUp" *ngIf="isSortDirectionAscending && sortColumn === 'ClientLoanNumber'"></mat-icon>
          </th>
          <th scope="col" class="sortable column-width-9vw" [ngClass]="{'active-sort-column': sortColumn == 'VendorOrderNumber'}" (click)="sortByColumn('VendorOrderNumber')" (keyup)="handleKeyUp($event, 'VendorOrderNumber')">
            3rd Party Order ID
            <mat-icon class="tooltip-icon" matTooltip="An additional number created by the 3rd party title service used to track the order within the Clear Sign system" matTooltipPosition="below" matTooltipShowDelay="500" svgIcon="information"></mat-icon>
            <mat-icon class="tooltip-icon" svgIcon="arrowDown" *ngIf="!isSortDirectionAscending && sortColumn === 'VendorOrderNumber'"></mat-icon>
            <mat-icon class="tooltip-icon" svgIcon="arrowUp" *ngIf="isSortDirectionAscending && sortColumn === 'VendorOrderNumber'"></mat-icon>
          </th>
          <th scope="col" class="column-width-9vw">
            Package GUID
          </th>
          <th *ngIf="isOrderManager && (isPortalAssigneeEnabled$ | async)" scope="col" class="column-width-9vw">
            Assigned To
          </th>
          <th scope="col" class="sortable column-width-13vw" [ngClass]="{'active-sort-column': sortColumn == 'ScheduledDateTime'}" (click)="sortByColumn('ScheduledDateTime')" (keyup)="handleKeyUp($event, 'ScheduledDateTime')">
            Scheduled Date & Time
            <mat-icon class="tooltip-icon" matTooltip="Time is based on the property address' time zone." matTooltipPosition="below" matTooltipShowDelay="500" svgIcon="information"></mat-icon>
            <mat-icon class="tooltip-icon" svgIcon="arrowDown" *ngIf="!isSortDirectionAscending && sortColumn === 'ScheduledDateTime'"></mat-icon>
            <mat-icon class="tooltip-icon" svgIcon="arrowUp" *ngIf="isSortDirectionAscending && sortColumn === 'ScheduledDateTime'"></mat-icon>
          </th>
          <th scope="col" class="text-start column-width-9vw">
            Participants
          </th>
          <th scope="col" class="text-start column-width-13vw">
            Address
          </th>
          <th scope="col" class="sortable column-width-8vw " [ngClass]="{'active-sort-column': sortColumn == 'ProductType'}" (click)="sortByColumn('ProductType')" (keyup)="handleKeyUp($event, 'ProductType')">
            Type
            <mat-icon class="tooltip-icon" matTooltip="Closing types: RON (Remote Online Notarization), KRON (Known Signer Remote Online Notarization), IPEN (In-Person Electronic Notarization), Hybrid (partially in-person and online)" matTooltipPosition="below" matTooltipShowDelay="500" svgIcon="information"></mat-icon>
            <mat-icon class="tooltip-icon" svgIcon="arrowDown" *ngIf="!isSortDirectionAscending && sortColumn === 'ProductType'"></mat-icon>
            <mat-icon class="tooltip-icon" svgIcon="arrowUp" *ngIf="isSortDirectionAscending && sortColumn === 'ProductType'"></mat-icon>
          </th>
          <th scope="col" class="sortable column-width-13vw " [ngClass]="{'active-sort-column': sortColumn == 'StatusCode'}" (click)="sortByColumn('StatusCode')" (keyup)="handleKeyUp($event, 'StatusCode')">
            Status
            <mat-icon class="tooltip-icon" svgIcon="arrowDown" *ngIf="!isSortDirectionAscending && sortColumn === 'StatusCode'"></mat-icon>
            <mat-icon class="tooltip-icon" svgIcon="arrowUp" *ngIf="isSortDirectionAscending && sortColumn === 'StatusCode'"></mat-icon>
          </th>
        </tr>
      </thead>
      <tbody>
        <div *ngIf="
            (filterForm?.searchResult$ | async) !== undefined;
            then displayResults;
            else displayEmpty
          "></div>
        <ng-template #displayEmpty>
          <tr #displayEmpty>
            <td colspan="7" style="text-align: center">
              <em>No results found</em>
            </td>
          </tr>
        </ng-template>
        <ng-template #displayResults>
          <ng-container *ngIf="filterForm?.searchResult$ | async as results">
            <tr *ngFor="let result of results.results" data-cy="orderRecord">
              <td class="column-width-9vw"
                  [title]="result.order.id">
                <a [routerLink]="['/order-detail', result.order.id]"
                   class="nav-link">{{ result.order.id }}</a>
              </td>
              <td class="column-width-9vw truncate"
                  [title]="result.order.loanIdentifier">
                {{ result.order.loanIdentifier }}
              </td>
              <td class="column-width-9vw truncate"
                  [title]="result.order.thirdPartyOrderIdentifier">
                {{ result.order.thirdPartyOrderIdentifier }}
              </td>
              <td class="column-width-9vw truncate"
                  [title]="result.order.packageGuid">
                {{ result.order.packageGuid }}
              </td>
              <td *ngIf="isOrderManager && (isPortalAssigneeEnabled$ | async)">
                <ng-select class="column-width-9vw"
                           [items]="(result.assigneesList$ | async)"
                           bindLabel="fullName"
                           [virtualScroll]="true"
                           [clearable]="false"
                           [searchFn]="assigneeSearchFn"
                           bindValue="accountId"
                           labelForId="assignees"
                           (change)="setAssignee(result.order.id, $event)"
                           [placeholder]="(result.currentAssigneeName$ | async)">
                  <ng-template ng-option-tmp let-item="item">
                    <div class="text-truncate"
                         ngbTooltip="{{ item.fullName }} {{item.emailAddress}}"
                         placement="right"
                         container="body"
                         openDelay="500">
                      <span class="fw-bold">{{item.fullName}}</span> <p class="emailAddress text-truncate">{{item.emailAddress}}</p>
                    </div>
                  </ng-template>
                  <ng-template ng-label-tmp let-item="item" let-search="searchTerm" let-index="index">
                    <div class="text-truncate">
                      {{item.fullName}}
                    </div>
                  </ng-template>
                </ng-select>
              </td>
              <td class="column-width-13vw truncate"
                  [title]="(convertScheduledDateTime(result.order.scheduledDateTime) | date: 'M/d/yyyy h:mm a')">
                {{
                  convertScheduledDateTime(result.order.scheduledDateTime)
                    | date: "M/d/yyyy &nbsp;&nbsp;&nbsp; h:mm a"
                }}
              </td>
              <td class="text-start column-width-9vw truncate"
                  [innerHTML]="result.borrowerNames.join(', ')"
                  [title]="result.borrowerNames.join(', ')"></td>
              <td class="text-start column-width-13vw truncate"
                  [title]="result.order.propertyAddress.streetAddress1 + ', ' + result.order.propertyAddress.city + ', ' + result.order.propertyAddress.stateCode + ' ' + result.order.propertyAddress.zipCode">
                {{ result.order.propertyAddress.streetAddress1 }},
                {{ result.order.propertyAddress.city }},
                {{ result.order.propertyAddress.stateCode }}
                {{ result.order.propertyAddress.zipCode }}
              </td>
              <td class="column-width-8vw truncate" *ngIf="result.order.productType === 'RemoteSigning'">
                <span class="pill">RON</span>
              <td class="column-width-8vw truncate" *ngIf="result.order.productType === 'IPEN'">
                <span class="pill">IPEN</span>
              <td class="column-width-8vw truncate" *ngIf="result.order.productType === 'Hybrid'">
                <span class="pill">Hybrid</span>
              </td>
              <td class="column-width-8vw truncate" *ngIf="result.order.productType === 'KnownSignerRON'">
                <span class="pill">KRON</span>
              <td class="column-width-8vw truncate" *ngIf="result.order.productType === 'eSign'">
                <span class="pill">eSign</span>
              </td>
              <td class="column-width-13vw truncate" *ngIf="result.order.statusCode === 'READY'">
                <span class="pill ready">
                  <mat-icon class="tooltip-icon" svgIcon="thumpUp-alt"></mat-icon> Ready
                </span>
              </td>
              <td class="column-width-13vw truncate" *ngIf="result.order.statusCode === 'INPROGRESS'">
                <span class="pill info">
                  <mat-icon class="tooltip-icon" svgIcon="sync"></mat-icon> In Progress
                </span>
              </td>
              <td class="column-width-13vw truncate" *ngIf="result.order.statusCode === 'SIGNING'">
                <span class="pill info">
                  <mat-icon class="tooltip-icon" svgIcon="sync"></mat-icon> Signing
                </span>
              </td>
              <td class="column-width-13vw truncate" *ngIf="result.order.statusCode === 'SIGNINGFAILED'">
                <span class="pill error">
                  <mat-icon class="tooltip-icon" svgIcon="close"></mat-icon> Signing Failed
                </span>
              </td>
              <td class="column-width-13vw truncate" *ngIf="result.order.statusCode === 'OPTOUT'">
                <span class="pill error">
                  <mat-icon class="tooltip-icon" svgIcon="close"></mat-icon> Opted-Out
                </span>
              </td>
              <td class="column-width-13vw truncate" *ngIf="result.order.statusCode === 'CANCELLED'">
                <span class="pill error">
                  <mat-icon class="tooltip-icon" svgIcon="close"></mat-icon> Cancelled
                </span>
              </td>
              <td class="column-width-13vw truncate" *ngIf="result.order.statusCode === 'SESSIONCOMPLETE'">
                <span class="pill info">
                  <mat-icon class="tooltip-icon" svgIcon="sync"></mat-icon> Session Complete
                </span>
              </td>
              <td class="column-width-13vw truncate" *ngIf="result.order.statusCode === 'VAULTING'">
                <span class="pill info">
                  <mat-icon class="tooltip-icon" svgIcon="sync"></mat-icon> Vaulting
                </span>
              </td>
              <td class="column-width-13vw truncate" *ngIf="result.order.statusCode === 'VAULTINGFAILED'">
                <span class="pill error">
                  <mat-icon class="tooltip-icon truncate" svgIcon="close"></mat-icon> Vaulting Failed
                </span>
              </td>
              <td class="column-width-13vw truncate" *ngIf="result.order.statusCode === 'COMPLETE'">
                <span class="pill complete">
                  <mat-icon class="tooltip-icon" svgIcon="check"></mat-icon> Complete
                </span>
              </td>
            </tr>
          </ng-container>
        </ng-template>
      </tbody>
    </table>

    <div class="row pagination-section">
      <div class="col align-self-end">
        <app-pagination-form *ngIf="(filterForm?.searchResult$ | async)"
                             [numPages]="filterForm?.totalPages"
                             [currentPage]="filterForm?.pageNumber"
                             [currentItemsPerPage]="filterForm?.pageSize"
                             [canGoForward]="filterForm?.canMoveForward"
                             [canGoBackward]="filterForm?.canMoveBackward"
                             (change)="onPaginatorChanged()">
        </app-pagination-form>
      </div>
    </div>
  </div>
</ng-container>
